import React, { useEffect, useState } from "react";
import { Button, Stack, Typography } from "@mui/material";

import Section1Img from "./Section1Img.png";

import Img12 from "./Frame44.png";

const Section1 = () => {
  const text = "take action".split(" ");
  const colors = ["#1a1aff", "#7a00cc", "#2e5cb8", "#666699", "#9900e6"]; // Dark colors array
  const [colorIndex, setColorIndex] = useState(0);

  // Change color every 2 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      setColorIndex((prevIndex) => (prevIndex + 1) % colors.length);
    }, 2000);

    return () => clearInterval(interval); // Clean up the interval on component unmount
  }, [colors.length]);

  return (
    <Stack
      sx={{
        display: "flex",
        flexDirection: "row",
        justifyContent: "center",
        alignItems: "center", // Vertically center
        // background: "linear-gradient(to right, #cce7ff, #f4e3ff)", // Gradient background
        // boxShadow: "0px 4px 15px rgba(0, 0, 0, 0.2)", // Add soft shadow
        height: { xl: "70vh", lg: "600px", md: "600px", sm: "600px" }, // Ensure the Stack has a defined height
        // border: "1px solid red",
        backgroundImage: `url(${Img12})`, // Replace with the path to your image
        backgroundSize: "cover", // Ensure the image covers the entire Stack
        backgroundPosition: "center", // Center the image
        backgroundRepeat: "no-repeat", // Prevent tiling
        border: "none",
      }}
    >
      <Stack
        sx={{
          display: "flex",
          flexDirection: {
            xl: "row",
            lg: "row",
            md: "row",
            sm: "row",
            xs: "column",
          },
          justifyContent: "space-between", // Ensure content is aligned
          width: { xs: "100%", sm: "90%", md: "80%", lg: "80%" }, // Adjust width
          height: { xl: "100%", lg: "100%", xs: "50%" },
          gap: {
            xl: 2,
            lg: 2,
            md: 2,
            sm: 2,
            xs: 2,
          },
          // border: "1px solid red",
        }}
      >
        {/* First Stack with Text and Buttons */}
        <Stack
          sx={{
            // height: "358px",
            width: { xl: "50%", lg: "50%", md: "50%", sm: "50%", xs: "100%" },
            // border: "1px solid blue",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            paddingLeft: { xl: "none", lg: "none", sm: "none", xs: "24px" },
            paddingRight: { xl: "none", lg: "none", sm: "none", xs: "24px" },
          }}
        >
          <Stack
            sx={{
              fontSize: {
                xs: "26px",
                sm: "34px",
                md: "40px",
                lg: "48px",
                xl: "52px",
              },
              fontWeight: 600,
              color: "black",
              lineHeight: {
                xs: "32px",
                sm: "34px",
                md: "42px",
                lg: "52px",
                xl: "52px",
              },
              textAlign: "justify",
              // border: "1px solid red",
              position: "relative",
              bottom: { xl: "100px", lg: "0px", md: "0px", sm: "0px", xs: "0px" },
              // marginBottom: { xl: "80px" },
            }}
          >
            <p style={{ margin: "0px" }}>
              Comprehensive whatsApp use cases for various industries
            </p>
          </Stack>

          <Stack
            sx={{
              fontSize: {
                xs: "18px",
                sm: "18px",
                md: "21px",
                lg: "24px",
                xl: "24px",
              },
              fontWeight: 300,
              color: "black",
              lineHeight: {
                xs: "24px",
                sm: "18px",
                md: "24px",
                lg: "34px",
                xl: "34px",
              },
              textAlign: "justify",
              marginTop: "20px",
              position: "relative",
              bottom: { xl: "60px", lg: "0px", md: "0px", sm: "0px", xs: "0px" },
            }}
          >
            Get an in-depth look at how businesses across multiple industries
            are using AiSensy to acquire, engageand drive 180x ROI with
            WhatsApp Marketing.
          </Stack>

          <Stack
            sx={{
              display: "flex",
              flexDirection: {
                xs: "column",
                sm: "column",
                md: "column",
                lg: "row",
                xl: "row",
              },
              justifyContent: "center",
              marginTop: "28px",
            }}
          >
            <Stack
              sx={{
                marginRight: {
                  xs: "0px",
                  sm: "0px",
                  md: "0px",
                  lg: "20px",
                  xl: "20px",
                },
                marginBottom: {
                  xs: "20px",
                  sm: "20px",
                  md: "20px",
                  lg: "0px",
                  xl: "0px",
                },
              }}
            >
              <Button variant="contained" size="large">
                Schedule Demo{" "}
                <span>
                  <b
                    style={{
                      position: "relative",
                      bottom: "2px",
                      marginLeft: "8px",
                    }}
                  >
                    →
                  </b>
                </span>
              </Button>
            </Stack>
            {/* <Stack>
              <Button variant="outlined" size="large">
                Talk to a Human
              </Button>
            </Stack> */}
          </Stack>
        </Stack>

        {/* Second Stack with Image */}
        <Stack
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",

            width: { xl: "50%", lg: "50%", md: "50%", sm: "50%", xs: "100%" },
            // background: "rgba(255, 255, 255, 0.1)", // Semi-transparent white
            // backdropFilter: "blur(4px)", // Frosted glass effect
            // boxShadow: "0 4px 30px rgba(0, 0, 0, 0.1)", // Subtle shadow for depth
            // padding: "16px", // Inner padding for spacing
            // border: "1px solid blue",
          }}
        >
          <img
            src={Section1Img}
            alt="Section Illustration"
            style={{
              maxWidth: "100%",
              height: "80%",
            }}
          />
          {/* <ClockWithPopup /> */}
          {/* <ClockAnimation /> */}
          {/* <AnimationClock /> */}
        </Stack>
      </Stack>
    </Stack>
  );
};

export default Section1;
